import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Angular2SignaturepadModule } from 'angular2-signaturepad';
import { SignatureInputComponent } from './signature-input.component';



@NgModule({
  declarations: [SignatureInputComponent],
  imports: [
    CommonModule,
    Angular2SignaturepadModule,
  ],
  exports: [SignatureInputComponent,]
})
export class SignatureInputModule { }
